
  <nav class="navbar bg-custom">
    <div class="grid margin-0">
      <div class="
        col-12
        sm:col-6
        md:col-6
        lg:col-3
        xl:col-3
        bg-custom-area
        footer-flex
      ">
        <h1 class="footer-title">CONTACTO</h1>
        <div class="footer-option">
          <label><i class="pi pi-send"></i> Email: </label>ventas&#64;e-onemall.co
        </div>
      </div>

      <div class="
        col-12
        sm:col-6
        md:col-6
        lg:col-3
        xl:col-3
        bg-custom-area
        footer-flex
      ">
        <h1 class="footer-title">REDES</h1>
        <div class="custom-social-networks">
          <a href="https://www.youtube.com/" target="_blank">
            <div class="custom_network footer-option" ><i class="pi pi-youtube"></i></div>
          </a>
          <a href="https://www.instagram.com/" target="_blank">
            <div class="custom_network footer-option" ><i class="pi pi-instagram"></i></div>
          </a>
        </div>
      </div>

      <div class="
        col-12
        sm:col-6
        md:col-6
        lg:col-3
        xl:col-3
        bg-custom-area
        footer-flex
      ">
        <h1 class="footer-title">ADICIONALES</h1>
          <h3 class="my-2"><a class="font-sm text-white no-underline"  [routerLink]="['/termns-and-conditions']"><p class="footer-option my-0">Terminos y condiciones</p></a></h3>
      </div>

      <div class="
          col-12
          sm:col-6
          md:col-6
          lg:col-3
          xl:col-3
          bg-custom-area
          footer-flex
        ">
          <h1 class="footer-title">MI CUENTA</h1>
          <h3 class="my-2"><a class="font-sm text-white no-underline footer-option"  [routerLink]="['/account']"><p class="footer-option my-0">Mi cuenta</p></a></h3>
          <h3 class="my-2"><a class="font-sm text-white no-underline footer-option"  [routerLink]="['/shopping-car']"><p class="footer-option my-0">Carrito de compras</p></a></h3>
      </div>

      <div class="
        col-12
        sm:col-12
        md:col-12
        lg:col-12
        xl:col-12
        bg-custom-area
        custom-need-help
        grid
        margin-0
      ">
        <div class="
          col-12
          sm:col-12
          md:col-9
          lg:col-9
          xl:col-9
        ">
          <h1>¿NECESITA AYUDA? COMUNIQUESE CON NOSOTROS</h1>
        </div>
        <div class="
          col-12
          sm:col-12
          md:col-3
          lg:col-3
          xl:col-3
        ">
          <p-button label="SUSCRIBETE" ></p-button>
        </div>
      </div>

      <div class="
        col-12
        sm:col-12
        md:col-12
        lg:col-12
        xl:col-12
        bg-custom-area
        grid
        margin-0
      ">
        <div class="
          col-12
          sm:col-12
          md:col-8
          lg:col-8
          xl:col-8
        ">
          <h1>DESCARGUE NUESTRA APP</h1>
        </div>
        <div class="
          col-12
          sm:col-12
          md:col-4
          lg:col-4
          xl:col-4
        "
          style="text-align: right;"
        >
          <h3>&copy; 2020 tienda.onemall.co</h3>
        </div>
      </div>
    </div>
  </nav>
